import appDataSliceReducer from "./features/appData/appDataSlice";
// import annotationSlice from "./features/annotation/annotationSlice";
import linkPreviewSlice from "./features/linkPreview/linkPreviewSlice";
import connectedAppsSlice from "./features/connectedApps/connectedAppsSlice";
import accountSlice from "./features/account/accountSlice";
import { configureStore } from "@reduxjs/toolkit";
import { loadState } from "../utils/localStorage";
import agentSlice from "./features/agent/agentSlice";
const preloadedState = loadState();

const store = configureStore({
  preloadedState: preloadedState,
  reducer: {
    appData: appDataSliceReducer,
    account: accountSlice,
    linkPreview: linkPreviewSlice,
    connectedApps: connectedAppsSlice,
    agent: agentSlice,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
